var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.loading,
          expression: "loading",
        },
      ],
      staticClass: "svg-wrap",
    },
    [
      _c("div", {
        ref: "container",
        staticStyle: { width: "100%", height: "100%" },
      }),
      _c(
        "el-popover",
        {
          attrs: {
            placement: "bottom",
            trigger: "manual",
            "visible-arrow": false,
            content: _vm.content,
            "popper-class": "d3-scale-percent",
          },
          model: {
            value: _vm.visible,
            callback: function ($$v) {
              _vm.visible = $$v
            },
            expression: "visible",
          },
        },
        [
          _c("div", {
            staticClass: "btn",
            attrs: { slot: "reference" },
            on: {
              click: function ($event) {
                _vm.visible = !_vm.visible
              },
            },
            slot: "reference",
          }),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }